import {EducationEntryLayout} from "../EducationEntryLayout";
import * as React from "react";

export const generateEducationEntries = (educationEntries: any[]) =>
{
	const returnValue = educationEntries.map((entry) =>
	{
		const outgoingProps = {
			entry
		}
		const innerReturnValue = <EducationEntryLayout {...outgoingProps} />;
		return innerReturnValue;
	});
	return returnValue;
};
